<template>
  <div class="row">
    <div class="col-lg-12">
      <h2 class="page-header">
        Edital {{ cargo.edital.numero }} <br />
        <small class="text-muted">{{ cargo.descricao }}</small>
      </h2>

      <div class="row">
        <div class="col-xs-12">
          <div class="col-sm-3 text-center">
            <label>Data de Homologação</label>
            <p>{{ cargo.data_homologacao }}</p>
          </div>
          <div class="col-sm-3 text-center">
            <label>Total de vagas</label>
            <p>{{ cargo.vagas }}</p>
          </div>
          <div class="col-sm-3 text-center">
            <label>Validade</label>
            <p>{{ cargo.data_validade }}</p>
          </div>
          <div class="col-sm-3 text-center">
            <label>Data da ultima nomeação</label>
            <p>{{ cargo.ultima_nomeacao }}</p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
            <div class="panel panel-primary">
              <div class="panel-heading">
                <div class="row">
                  <div class="col-xs-3">
                    <font-awesome-icon :icon="'address-card'" size="4x" />
                  </div>
                  <div class="col-xs-9 text-right">
                    <div class="huge">{{ habilitados.length }}</div>
                    <div>Habilitados</div>
                  </div>
                </div>
              </div>
              <a @click="scrollToElement('habilitados')">
                <div class="panel-footer">
                  <span class="pull-left">Detalhes</span>
                  <span class="pull-right"
                    ><font-awesome-icon
                      :icon="'arrow-alt-circle-right'"
                    ></font-awesome-icon
                  ></span>
                  <div class="clearfix"></div>
                </div>
              </a>
            </div>
          </div>

          <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
            <div class="panel panel-primary">
              <div class="panel-heading">
                <div class="row">
                  <div class="col-xs-3">
                    <font-awesome-icon :icon="'bullhorn'" size="4x" />
                  </div>
                  <div class="col-xs-9 text-right">
                    <div class="huge">{{ nomeados.length }}</div>
                    <div>Nomeados</div>
                  </div>
                </div>
              </div>
              <a @click="scrollToElement('nomeados')">
                <div class="panel-footer">
                  <span class="pull-left">Detalhes</span>
                  <span class="pull-right"
                    ><font-awesome-icon
                      :icon="'arrow-alt-circle-right'"
                    ></font-awesome-icon
                  ></span>
                  <div class="clearfix"></div>
                </div>
              </a>
            </div>
          </div>

          <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
            <div class="panel panel-primary">
              <div class="panel-heading">
                <div class="row">
                  <div class="col-xs-3">
                    <font-awesome-icon :icon="'user-check'" size="4x" />
                  </div>
                  <div class="col-xs-9 text-right">
                    <div class="huge">{{ empossados.length }}</div>
                    <div>Empossados</div>
                  </div>
                </div>
              </div>
              <a @click="scrollToElement('empossados')">
                <div class="panel-footer">
                  <span class="pull-left">Detalhes</span>
                  <span class="pull-right"
                    ><font-awesome-icon
                      :icon="'arrow-alt-circle-right'"
                    ></font-awesome-icon
                  ></span>
                  <div class="clearfix"></div>
                </div>
              </a>
            </div>
          </div>

          <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
            <div class="panel panel-primary">
              <div class="panel-heading">
                <div class="row">
                  <div class="col-xs-3">
                    <font-awesome-icon :icon="'user-times'" size="4x" />
                  </div>
                  <div class="col-xs-9 text-right">
                    <div class="huge">{{ revogados.length }}</div>
                    <div>Revogados</div>
                  </div>
                </div>
              </div>
              <a @click="scrollToElement('revogados')">
                <div class="panel-footer">
                  <span class="pull-left">Detalhes</span>
                  <span class="pull-right"
                    ><font-awesome-icon
                      :icon="'arrow-alt-circle-right'"
                    ></font-awesome-icon
                  ></span>
                  <div class="clearfix"></div>
                </div>
              </a>
            </div>
          </div>

          <div
            v-if="userPerfil == 'admin'"
            class="col-xs-12 col-sm-6 col-md-4 col-lg-3"
          >
            <div class="panel panel-primary">
              <div class="panel-heading">
                <div class="row">
                  <div class="col-xs-3">
                    <font-awesome-icon :icon="'users'" size="4x" />
                  </div>
                  <div class="col-xs-9 text-right">
                    <div class="huge">{{ revogados.length }}</div>
                    <div>Vagas do Quadro Permanente</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <h3 id="habilitados">
            <font-awesome-icon :icon="'address-card'" />
            Habilitados
          </h3>
          <data-table
            ref="list_habilitados"
            :dados="habilitadosNormal"
            :fields="fields.habilitados"
            :carregando="isLoading"
          >
          </data-table>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <h3>
            <font-awesome-icon :icon="'address-card'" />
            Habilitados - PCD
          </h3>
          <data-table
            ref="list_habilitadosPCD"
            :dados="habilitadosPCD"
            :fields="fields.habilitados"
            :carregando="isLoading"
          >
          </data-table>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <h3 id="nomeados">
            <font-awesome-icon :icon="'bullhorn'" />
            Nomeados
          </h3>
          <data-table
            ref="list_nomeados"
            :dados="nomeados"
            :fields="fields.nomeados"
            :carregando="isLoading"
          >
            <template slot="columncustom" slot-scope="props">
              {{ retornarTipoCandidato(props.rowData) }}
            </template>
          </data-table>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <h3 id="empossados">
            <font-awesome-icon :icon="'user-check'" />
            Empossados
          </h3>
          <data-table
            ref="list_empossados"
            :dados="empossados"
            :fields="fields.empossados"
            :carregando="isLoading"
          >
            <template slot="columncustom" slot-scope="props">
              {{ retornarTipoCandidato(props.rowData) }}
            </template>
          </data-table>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <h3 id="revogados">
            <font-awesome-icon :icon="'user-times'" />
            Revogados
          </h3>
          <data-table
            ref="list_revogados"
            :dados="revogados"
            :fields="fields.revogados"
            :carregando="isLoading"
          >
            <template slot="columncustom" slot-scope="props">
              {{ retornarTipoCandidato(props.rowData) }}
            </template>
          </data-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from '@/components/common/NoApiTable'
import { request } from '@/request'
import { scrollToElement } from '@/utils'

const columnCustom = [{ name: '__slot:column', title: 'Tipo Candidato' }]

const columnsDefault = [
  { name: 'classificacao', title: 'Classificação' },
  { name: 'nome', title: 'Nome' },
  {
    name: 'data_habilitado',
    title: 'Data Habilitação',
    titleClass: 'text-center',
    dataClass: 'text-center'
  }
]

export default {
  name: 'acompanhamento_detalhes_cargo',
  components: {
    DataTable
  },
  data() {
    return {
      fields: {
        habilitados: [...columnsDefault],
        nomeados: [
          ...columnCustom,
          ...columnsDefault,
          {
            name: 'data_nomeacao',
            title: 'Data Nomeação',
            titleClass: 'text-center',
            dataClass: 'text-center'
          }
        ],
        empossados: [
          ...columnCustom,
          ...columnsDefault,
          {
            name: 'data_nomeacao',
            title: 'Data Nomeação',
            titleClass: 'text-center',
            dataClass: 'text-center'
          },
          {
            name: 'data_empossado',
            title: 'Data Empossado',
            titleClass: 'text-center',
            dataClass: 'text-center'
          }
        ],
        revogados: [
          ...columnCustom,
          ...columnsDefault,
          {
            name: 'data_nomeacao',
            title: 'Data Nomeação',
            titleClass: 'text-center',
            dataClass: 'text-center'
          },
          {
            name: 'data_revogacao',
            title: 'Data Revogação',
            titleClass: 'text-center',
            dataClass: 'text-center'
          }
        ]
      },
      cargo: {
        id: 0,
        data_homologacao: '',
        data_validade: '',
        descricao: '',
        edital: { id: 0, numero: '' },
        ultima_nomeacao: '',
        vagas: 0,
        vagas_QP: 0,
        vagas_cotas: 0,
        vagas_pcd: 0
      },
      habilitados: [],
      isLoading: false,
      params: { edital_id: 0, cargo_id: 0 }
    }
  },
  beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login')
    }
  },
  created() {
    this.params = this.$router.history.current.params

    this.carregarCargo()
    this.carregarHabilitados()
  },
  computed: {
    userPerfil() {
      const { perfis } = this.$store.state.user

      if (
        (perfis && perfis.includes('admin')) ||
        perfis.includes('concursos-admin')
      )
        return 'admin'
      else return 'default'
    },
    habilitadosNormal() {
      return this.habilitados.filter(item => item.tipo_pcd === 0)
    },
    habilitadosPCD() {
      return this.habilitados.filter(item => item.tipo_pcd === 1)
    },
    nomeados() {
      return this.habilitados.filter(item => {
        return (
          item.data_nomeacao && !item.data_empossado && !item.data_revogacao
        )
      })
    },
    empossados() {
      return this.habilitados.filter(item => !!item.data_empossado)
    },
    revogados() {
      return this.habilitados.filter(item => !!item.data_revogacao)
    }
  },
  methods: {
    retornarTipoCandidato({ tipo_pcd, tipo_cotas }) {
      if (tipo_pcd) {
        return 'PCD'
      }

      if (tipo_cotas) {
        return 'Cotas'
      }

      return 'Geral'
    },
    carregarCargo() {
      const { toogleLoading } = this
      const { cargo_id } = this.params

      toogleLoading()

      request
        .get(`cargo/${cargo_id}`)
        .then(response => (this.cargo = response.data))
        .catch(error => console.log(error.response))
        .then(toogleLoading)
    },
    carregarHabilitados() {
      const { toogleLoading, params } = this

      toogleLoading()

      request
        .get('habilitado', { params })
        .then(response => (this.habilitados = response.data))
        .catch(error => console.log(error.response))
        .then(toogleLoading)
    },
    toogleLoading() {
      this.isLoading = !this.isLoading
    },
    scrollToElement
  }
}
</script>

<style scoped>
.huge {
  font-size: 40px;
}
.panel-primary > .panel-heading {
  background-color: #00615c !important;
  border-color: #00615c !important;
}
.panel-primary {
  border-color: #00615c !important;
}

a div.panel-footer {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/admin/concursos/acompanhamento/DetailsCargo.vue